import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Stack,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  CircularProgress,
} from '@mui/material'
import { Scale } from '@mui/icons-material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs from 'dayjs'

const WeightDialog = ({ 
  open, 
  onClose, 
  entry,
  newWeight,
  setNewWeight,
  weightDate,
  setWeightDate,
  weightUnit,
  setWeightUnit,
  onAddWeight,
  getUnitLabel,
  updateEntryMutation
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Scale color="primary" />
          Add Weight Record
        </Box>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 1 }}>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Weight"
              type="number"
              value={newWeight}
              onChange={(e) => setNewWeight(e.target.value)}
              sx={{ flex: 2 }}
              placeholder={`Enter weight in ${getUnitLabel(weightUnit)}`}
              slotProps={{ 
                htmlInput: { 
                  step: weightUnit === 'g' ? "1" : "0.1", 
                  min: "0",
                  max: weightUnit === 'g' ? "50000" : weightUnit === 'oz' ? "1600" : "100"
                }
              }}
            />
            <FormControl sx={{ flex: 1, minWidth: 100 }}>
              <InputLabel>Unit</InputLabel>
              <Select
                value={weightUnit}
                label="Unit"
                onChange={(e) => setWeightUnit(e.target.value)}
              >
                <MenuItem value="lbs">Pounds</MenuItem>
                <MenuItem value="oz">Ounces</MenuItem>
                <MenuItem value="g">Grams</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <DatePicker
            label="Date"
            value={weightDate ? dayjs(weightDate) : null}
            onChange={(newValue) => setWeightDate(newValue ? newValue.format('YYYY-MM-DD') : '')}
            maxDate={dayjs()}
            slotProps={{
              textField: {
                fullWidth: true
              }
            }}
          />
          <Alert severity="info" sx={{ mt: 2 }}>
            This weight record will be added to {entry?.name || 'this bird'}'s history and help track growth and health trends.
          </Alert>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Cancel
        </Button>
        <Button 
          onClick={onAddWeight}
          variant="contained"
          disabled={!newWeight || !weightDate || updateEntryMutation?.isPending}
          startIcon={updateEntryMutation?.isPending ? <CircularProgress size={16} /> : <Scale />}
        >
          {updateEntryMutation?.isPending ? 'Adding...' : 'Add Weight'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default WeightDialog